import { useLanguage } from "@/i18n/LanguageProvider";

const OPTIONS = [["en", "EN"], ["pt", "PT"]];

export const LanguageToggle = () => {
  const { lang, setLang } = useLanguage();
  return (
    <div className="flex items-center rounded-md border border-slate-700 p-0.5 font-mono text-[11px]" role="group" aria-label="Language" data-testid="language-toggle">
      {OPTIONS.map(([value, label]) => (
        <button
          key={value}
          type="button"
          onClick={() => setLang(value)}
          aria-pressed={lang === value}
          data-testid={`language-toggle-${value}`}
          className={`px-2 py-1 rounded transition-colors duration-200 ${
            lang === value ? "bg-amber-500 text-[#0a1425] font-bold" : "text-slate-400 hover:text-slate-100"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
